import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { store } from '@/redux/store';
import { Buffer } from 'buffer';
import UnleashProvider from './components/UnleashProvider';
import { initializeVerisoul } from './common/verisoul';

if (!globalThis.Buffer) {
  globalThis.Buffer = Buffer;
}

// Initialize Verisoul early
initializeVerisoul();

Sentry.init({
  dsn: 'https://644a500fc284ca0cb59c93858328c8b4@o4508999291305984.ingest.us.sentry.io/4509247382618112',
  enabled: import.meta.env.PROD,
  sendDefaultPii: true,
});

const SentryErrorBoundary = Sentry.ErrorBoundary;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<div>An error has occurred</div>}>
      <Provider store={store}>
        <UnleashProvider>
          <Router>
            <App />
          </Router>
        </UnleashProvider>
      </Provider>
    </SentryErrorBoundary>
  </StrictMode>,
);
